import { IVehicle } from "@services/Vehicles/Vehicles";
import {logger as SentryLogger} from '@sentry/react';
import {ExchangeVehicle} from "@views/VehicleExchange/currentVehicleDetailsReducer";

export interface NewVehicleState {
  startingOdometer: number;
  selectedVehicle: ExchangeVehicle;
}

export const defaultExchangeVehicle: ExchangeVehicle = {
  id: '',
  make: '',
  model: '',
  year: '',
  color: '',
  license_plate: '',
  vin: '',
  current_meter_value: 0,
  body_type: '',
  group_ancestry: '',
  vehicle_status_name: null
};

export const defaultNewVehicleState: NewVehicleState = {
  startingOdometer: 0,
  selectedVehicle: defaultExchangeVehicle,
};


export type NewVehicleAction =
  | { type: "UPDATE_FIELD"; field: keyof NewVehicleState; value: string }
  | { type: "UPDATE_SELECTED_VEHICLE"; payload: IVehicle };


export function newVehicleReducer(state: NewVehicleState, action: NewVehicleAction): NewVehicleState {
  switch (action.type) {
    case "UPDATE_FIELD":
      SentryLogger.debug(`Updating field ${action.field} with value ${action.value}`);
      return { ...state, [action.field]: action.value };
    case "UPDATE_SELECTED_VEHICLE":
      //This translates the IVehicle to ExchangeVehicle
      const payload: any = action.payload
      payload.body_type = payload.specs.body_type;
      SentryLogger.debug(`Updating selected NewVehicle with payload: ${JSON.stringify(payload)}`);
      return {...state, selectedVehicle: payload};
    default:
      console.error(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}